import {atomIconSizes} from '@s-ui/react-atom-icon'
import IconCircleCheckOutline from '@adv-mt/mt-svg-icons/lib/CircleCheckOutline.js'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

export const NOTIFICATION_TYPES = {
  GENERIC_ERROR: 'genericError',
  IRRELEVANT_RESULTS_ERROR: 'irrelevantResultsError',
  NO_ANSWER_ERROR: 'noAnswerError',
  SUCCESS: 'success',
  TIMEOUT_ERROR: 'timeoutError',
  UNETHICAL_CONTENT_ERROR: 'unethicalContentError'
}

const sharedNotificationErrorConfig = {
  icon: <IconInfoOutline aria-hidden role="presentation" size={atomIconSizes.medium} />,
  type: NOTIFICATION_TYPES.ERROR
}

export const NOTIFICATIONS = {
  [NOTIFICATION_TYPES.GENERIC_ERROR]: {
    ...sharedNotificationErrorConfig,
    message: 'SEARCH_AI.NOTIFICATIONS.GENERIC_ERROR'
  },
  [NOTIFICATION_TYPES.IRRELEVANT_RESULTS_ERROR]: {
    ...sharedNotificationErrorConfig,
    message: 'SEARCH_AI.NOTIFICATIONS.IRRELEVANT_RESULTS_ERROR'
  },
  [NOTIFICATION_TYPES.NO_ANSWER_ERROR]: {
    ...sharedNotificationErrorConfig,
    message: 'SEARCH_AI.NOTIFICATIONS.NO_ANSWER_ERROR'
  },
  [NOTIFICATION_TYPES.TIMEOUT_ERROR]: {
    ...sharedNotificationErrorConfig,
    message: 'SEARCH_AI.NOTIFICATIONS.TIMEOUT_ERROR'
  },
  [NOTIFICATION_TYPES.UNETHICAL_CONTENT_ERROR]: {
    ...sharedNotificationErrorConfig,
    message: 'SEARCH_AI.NOTIFICATIONS.UNETHICAL_CONTENT_ERROR'
  },
  [NOTIFICATION_TYPES.SUCCESS]: {
    icon: <IconCircleCheckOutline size={atomIconSizes.medium} />,
    message: 'SEARCH_AI.NOTIFICATIONS.SUCCESS',
    type: NOTIFICATION_TYPES.SUCCESS
  }
}

export const NOTIFICATION_TYPES_DICTIONARY = {
  GENERIC_ERROR: NOTIFICATION_TYPES.GENERIC_ERROR,
  NO_CONTENT_ERROR: NOTIFICATION_TYPES.NO_ANSWER_ERROR,
  GATEWAY_TIMEOUT_ERROR: NOTIFICATION_TYPES.TIMEOUT_ERROR,
  INTERNAL_SERVER_ERROR_ERROR: NOTIFICATION_TYPES.GENERIC_ERROR,
  UNAVAILABLE_FOR_LEGAL_REASONS_ERROR: NOTIFICATION_TYPES.UNETHICAL_CONTENT_ERROR,
  UNPROCESSABLE_CONTENT_ERROR: NOTIFICATION_TYPES.IRRELEVANT_RESULTS_ERROR
}
